import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { SearchController } from '@mainrepo/app/core/controller/SearchController';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';
import { GenericModule } from '@modules/generic/generic.module';

@Component({
  selector: 'common-sematic-search-status',
  standalone: true,
  imports: [DependenciesModule,GenericModule],
  templateUrl: './sematic-search-status.component.html',
  styleUrl: './sematic-search-status.component.scss'
})
export class SematicSearchStatusComponent {
  universalService: any;
  searchService: any;
  localStorageService: any;
  router: any;
  searchController: any;
  impl: any;
  userData:any;
  showSearchStatusPopup: boolean = false;

  constructor(private globalService: GlobalService) {
    this.setEnvObjects(this.globalService);
  }
  @HostListener('document:keydown', ['$event'])
   onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape") {
    }
  }
  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef(),
    this.searchService = globalService.getSearchServiceRef();
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.router = globalService.getRouterRef();
  }
  async ngOnInit(): Promise<void> {
    this.searchController = SearchController.getInstance(this.globalService);
    this.impl = this.searchController.searchImplementation;
    this.userData = this.localStorageService.getUserData(true);

    this.registerEvents();
  }
  registerEvents(){
    let self = this;
    AppEvents.on(EventsList.SHOW_SEARCH_STATUS_POPUP, function(){
      setTimeout(()=>{
        self.showSearchStatusPopup = true;
      },300);
    });
  }
  async showSearchStatusDetails(){
    window.open(window.location.origin + '/searchdetails')
  }
}
